'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _mixSelectableChild = require('../utils/mix-selectable-child.js');

var _transition = require('../utils/transition.js');

var _dom = require('../utils/dom.js');

var _arrow_up = require('./imgs/arrow_up');

var _arrow_up2 = _interopRequireDefault(_arrow_up);

var _confirm = require('./imgs/confirm');

var _confirm2 = _interopRequireDefault(_confirm);

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

var _style = require('./style');

var _index = require('../dof-switch/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { DofSwitch: _index2.default },
  mixins: [(0, _mixSelectableChild.mixSelectableChild)('dof-card-group'), _colmo2.default, _diablo2.default],
  props: {
    collapsable: {
      type: Boolean,
      default: false
    },
    selectable: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'right'
    },
    // 标签背景色
    tagBg: {
      type: String,
      default: ''
    },
    // 卡片样式
    cardStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 右上角标记配置，normalColor常态颜色，clickedColor选中态颜色
    dotConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 是否选中态
    clicked: {
      type: Boolean,
      default: false
    },
    // 点击颜色
    touchColor: {
      type: String,
      required: false,
      default: ''
    },
    cardWrapperStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  model: {
    prop: 'selected',
    event: 'select'
  },
  data: function data() {
    return {
      active_: false,
      collapsed_: this.collapsed,
      clicked_: this.clicked,
      bodyHeight: 0,
      arrowUp: _arrow_up2.default,
      confirm: _confirm2.default,
      isTouching: false
    };
  },

  computed: {
    themeStyle: function themeStyle() {
      var _theme = this._theme || 'default';
      return _style.STYLE_MAP[_theme] || _style.STYLE_MAP['default'];
    },
    isActive: function isActive() {
      return this.selectable && this.selected || this.isSelected;
    },
    _cardStyle: function _cardStyle() {
      var tmp = { borderRadius: this.themeStyle.borderRadius };
      var style = _extends({
        backgroundColor: this._isColmo ? '#303237' : this._isDiablo ? '#171c1f' : '#fff'
      }, tmp, this.cardStyle);
      if (this.touchColor && this.isTouching) style.backgroundColor = this.touchColor;
      return style;
    },
    _cardWrapperStyle: function _cardWrapperStyle() {
      var style = _extends({
        'backgroundColor:active': this.touchColor ? this.touchColor : '',
        paddingLeft: '32px',
        paddingRight: '32px',
        paddingTop: '32px',
        paddingBottom: '32px'
      }, this.cardWrapperStyle);
      return style;
    },
    _tagBg: function _tagBg() {
      if (this.tagBg) return this.tagBg;
      return this._isColmo ? '#B35336' : '#00A4F2';
    }
  },
  mounted: function mounted() {
    this.initCollapsable();
  },

  methods: {
    initCollapsable: function initCollapsable() {
      var _this = this;

      if (!this.collapsable) {
        return;
      }
      this.$nextTick(function () {
        (0, _dom.getBoundingClientRect)(_this.$refs.body, function (res) {
          _this.bodyHeight = res.size.height;
          if (_this.collapsed_) {
            _this.collapseBody(0);
          } else {
            _this.expandeBody();
          }
        });
      });
      if (this.collapsed_) {
        this.collapseArrow();
      }
    },
    onSelect: function onSelect() {
      this.$emit('select', !this.selected);
      this.triggerSelect();

      this.$emit('clicked', this.clicked_ = !this.clicked_);
    },
    onCollapse: function onCollapse() {
      this.collapsed_ = !this.collapsed_;
      this.$emit('collapse', this.collapsed_);
      if (this.collapsed_) {
        this.collapseBody();
        this.collapseArrow();
      } else {
        this.expandeBody();
        this.expandeArrow();
      }
    },
    collapseBody: function collapseBody() {
      var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 360;

      _transition.Transition.Default().duration(duration).height(0).needLayout(true).run(this.$refs.body);
    },
    collapseArrow: function collapseArrow() {
      _transition.Transition.Default().rotateZ(-180).transformOrigin('center').run(this.$refs.arrow);
    },
    expandeBody: function expandeBody() {
      var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 360;

      _transition.Transition.Default().duration(duration).height(this.bodyHeight).needLayout(true).run(this.$refs.body);
    },
    expandeArrow: function expandeArrow() {
      _transition.Transition.Default().rotateZ(0).transformOrigin('center').run(this.$refs.arrow);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-card/index.vue
// module id = 309
// module chunks = 0 1